import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Send cookies on every request (session_token httpOnly cookie)
axios.defaults.withCredentials = true;

export const uploadCsv = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/upload`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const createSample = async () => {
  const { data } = await axios.post(`${API}/sample`);
  return data;
};

export const fetchDataset = async (sessionId, method = "linear", periods = 3) => {
  const { data } = await axios.get(`${API}/dataset/${sessionId}`, {
    params: { method, periods },
  });
  return data;
};

export const recomputeForecast = async (sessionId, method = "linear", periods = 3) => {
  const { data } = await axios.post(`${API}/forecast/${sessionId}`, { method, periods });
  return data;
};

export const fetchWhatIf = async (sessionId) => {
  const { data } = await axios.get(`${API}/whatif/${sessionId}`);
  return data;
};

export const listDatasets = async () => {
  const { data } = await axios.get(`${API}/datasets`);
  return data;
};

// ---------- Auth ----------

export const createAuthSession = async (sessionIdFromHash) => {
  const { data } = await axios.post(`${API}/auth/session`, { session_id: sessionIdFromHash });
  return data;
};

export const fetchCurrentUser = async () => {
  const { data } = await axios.get(`${API}/auth/me`);
  return data;
};

export const logout = async () => {
  const { data } = await axios.post(`${API}/auth/logout`, {});
  return data;
};
